/**
 * Templates para mantener tono "Steve Jobs para PYMEs" consistente
 */

export const templates = {
  hero: {
    prefix: [
      "Descubre cómo",
      "Imagina poder",
      "¿Y si pudieras",
    ],
    suffix: [
      "sin complicaciones técnicas",
      "aunque no sepas nada de tecnología",
      "empezando hoy mismo",
    ],
  },
  
  problem: {
    intro: "El problema que todos tenemos:",
    examples: [
      "No tengo tiempo para...",
      "No tengo presupuesto para...",
      "No sé por dónde empezar con...",
    ],
  },
  
  solution: {
    intro: "Aquí tienes {count} artículos para que puedas hacerte una pequeña idea y hacerlo tú",
    stepFormat: {
      whatItDoes: "¿Qué hace?",
      realExample: "Ejemplo real:",
      timeToStart: "Tiempo estimado:",
    },
  },
  
  cta: {
    question: "¿Te imaginas esto funcionando en tu día a día?",
    mainHeading: "¿Cómo quieres empezar?",
  },
};

/**
 * Palabras prohibidas (muy técnicas)
 */
export const forbiddenWords = [
  "implementar",
  "deployar",
  "integrar",
  "optimizar",
  "machine learning",
  "deep learning",
  "algoritmo",
  "framework",
];

/**
 * Alternativas recomendadas
 */
export const recommendedWords: Record<string, string> = {
  "implementar": "poner en marcha",
  "deployar": "activar",
  "integrar": "conectar",
  "optimizar": "mejorar",
  "machine learning": "inteligencia artificial",
  "algoritmo": "sistema",
  "framework": "herramienta",
};

/**
 * Genera copy para problema de negocio
 */
export function generateProblemCopy(businessProblem?: string): string {
  if (businessProblem) {
    return `${templates.problem.intro}\n"${businessProblem}"`;
  }
  
  return `${templates.problem.intro}\n"No tengo tiempo para crear contenido de calidad."`;
}

/**
 * Genera copy para introducción de soluciones
 */
export function generateSolutionIntroCopy(articleCount: number): string {
  return templates.solution.intro.replace("{count}", articleCount.toString());
}
